import React, { useState, useEffect, useRef } from "react";
import { Table, Col, Breadcrumb, Button, Space, Row } from "antd";
import { Link, useParams, useNavigate, useLocation, useSearchParams,} from "react-router-dom";
import { DownloadOutlined } from "@ant-design/icons";
import plogo from "../../image/plogo.png";
import { getRequest } from "../../axios";
import ButtonField from "../../common/htmlComponents/ButtonField";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import moment from 'moment';

const ApproveRFQView = () => {
    const [orderData, setOrderData] = useState(null);

    const { id } = useParams();
    const buttonRef = useRef(null);
    const [isDownloading, setIsDownloading] = useState(false);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(false);
    const pdfContainerRef = useRef(null);


    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);

   const action = queryParams.get("po_site_name");


    useEffect(() => {
        const getPoOrder = async () => {
            setLoading(true);
            try {
                const response = await getRequest(`po-order/${id}/po-copy-to-pr-rfq-approval/?po_site_name=${action}`);
                console.log(response);
                setOrderData(response.data.data);
                setLoading(false);
            } catch (error) {
                console.error("Error:", error);
                if (!error.response.data.success) {
                    setError(true);
                    setLoading(false);
                }
            }
        };
        getPoOrder();
    }, []);

    if (!orderData) {
        return <section style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            height: "100vh",
        }}>{!error && loading && (<span>Loading...</span>)}{error && !loading && (<span>Error</span>)}</section>;
    }
    const downloadAsPDF = () => {
        if (pdfContainerRef.current) {
            setIsDownloading(true);
            if (buttonRef.current) {
                buttonRef.current.classList.add("hide-in-pdf");
            }

            html2canvas(pdfContainerRef.current, {
                useCORS: true,
                scale: 1.5,
                logging: true,
            })
                .then((canvas) => {
                    const imgData = canvas.toDataURL("image/png");

                    const pdf = new jsPDF("l", "mm", "a4");
                    const imgProps = pdf.getImageProperties(imgData);
                    const pdfWidth = pdf.internal.pageSize.getWidth();
                    const pdfHeight = (imgProps.height * pdfWidth) / imgProps.width;
                    pdf.addImage(imgData, "PNG", 0, 0, pdfWidth, pdfHeight);
                    pdf.save(`Preview Purchase Order-${id}.pdf`);

                    if (buttonRef.current) {
                        buttonRef.current.classList.remove("hide-in-pdf");
                    }
                    setIsDownloading(false);
                })
                .catch((error) => {
                    console.error("Error generating PDF:", error);
                    if (buttonRef.current) {
                        buttonRef.current.classList.remove("hide-in-pdf");
                    }
                    setIsDownloading(false);
                });
        } else {
            console.error("PDF container reference is not defined.");
        }
    };
    const columns = [
        {
            title: "Sr. No.",
            dataIndex: "SrNo",
            width: "90px",
        },
        {
            title: "Item Description",
            dataIndex: "ItemDescription",
        },
        {
            title: "HSN",
            dataIndex: "HSN",
        },
        {
            title: "QTY",
            dataIndex: "QTY",
        },
        {
            title: "UOM",
            dataIndex: "UOM",
        },
        {
            title: "Delivery Date",
            dataIndex: "DeliveryDate",
        },
        {
            title: "Tax(%)",
            dataIndex: "Tax",
        }
    ];

    const data = orderData.material_description.map((item, index) => ({
        SrNo: index + 1,
        ItemDescription: item.material_name,
        HSN: item.hsn_code,
        QTY: item.qty,
        UOM: item.uom,
        DeliveryDate: item.delivery_date,
        Tax: item.tax
    }));

    return (
        <>
        <div className="invoice-container">
          <div className="ListingTopBar">
            <div className="pagenamewrap">
              <div className="pagename">
                <h3>Purchase Order View</h3>

                <Breadcrumb className="Breadcrumb-Sec">
                  <Breadcrumb.Item>
                    <Link to="/dashboard">Home</Link>
                  </Breadcrumb.Item>
                  <Breadcrumb.Item>
                    <Link to="/request-for-quotation/purchase-order-summary">Purchase Order</Link>
                  </Breadcrumb.Item>
                </Breadcrumb>
              </div>
              <Space>
                <ButtonField
                    className="BlueShadowBtn"
                    type="primary"
                    icon={<DownloadOutlined />}
                    label={isDownloading ? "Downloading..." : "Generate PDF"}
                    onClick={downloadAsPDF}
                    ref={buttonRef}
                >
                  Download
                </ButtonField>
              </Space>
            </div>
          </div>

          <section className="grid-sec mt-5" ref={pdfContainerRef}>
            <div className="PR-body">
              <div className="order-header">
                <div className="purchaselogo">

                    {orderData.company_name}
                </div>
                <div className="headdtl">
                  <table>
                    <tr>
                      <td>PO Number : </td>
                      <td>{orderData.po_number}</td>
                    </tr>
                    <tr>
                      <td>PO Date: </td>
                      <td> {orderData.po_created_date
                          ? moment(orderData.po_created_date, 'DD-MM-YYYY').format("DD/MM/YYYY")
                          : ""}</td>
                    </tr>
                    <tr>
                      <td>Payment Terms:</td>
                      <td>30 Days</td>
                    </tr>
                    <tr>
                      {/* <td>INCO Terms</td> */}
                      <td></td>
                    </tr>
                  </table>
                </div>
              </div>
              <Row gutter={[15]}>
                <Col xs={24} sm={24} md={8}>
                  <div className="orderpdtl">
                    <h3>Seller</h3>
                    <p>
                      <strong>Name :</strong> {orderData.vendor_details[0].vendor_name}
                    </p>
                    <p>
                      <strong>Mobile :</strong>{" "}
                        {orderData.vendor_details[0].phone_number}
                    </p>
                    <p>
                      <strong>Email :</strong> {orderData.vendor_details[0].email}
                    </p>
                    <div className="adrs" style={{ marginTop: "10px" }}>
                      <strong>Address :</strong> {`${orderData.vendor_details[0].vendor_address}, ${orderData.vendor_details[0].pincode_number}`}
                    </div>
                    <div className="gstn">
                      <strong>GSTN:</strong>{" "}
                        {orderData.vendor_details[0].gst_number}
                    </div>
                  </div>
                </Col>
                <Col xs={24} sm={24} md={8}>
                  <div className="orderpdtl">
                    <h3>BUYER</h3>
                    <p><strong>Name :</strong> {orderData.company_name}</p>
                    <p><strong>Mobile:  :</strong> {orderData.phone_number}</p>
                    <p><strong>Email :</strong>{orderData.email}</p>
                    <div className="adrs" style={{ marginTop: "10px" }}>
                      {/*<strong>Address :</strong> {`${orderData.company_details[0].registered_business_address_building}, ${orderData.company_details[0].registered_business_address_area}, ${orderData.company_details[0].registered_business_address_city}`}*/}
                    </div>
                    <div className="gstn">
                      <strong>GSTN:</strong>{" "}
                        {orderData.gst_number}
                    </div>
                  </div>
                </Col>
                <Col xs={24} sm={24} md={8}>
                  <div className="orderpdtl">
                    <h3>SITE LOCATION</h3>
                    <p><strong>Site Name: </strong>  {orderData.site_location[0].site_location}, {orderData.site_location[0].billing_city}</p>
                    <p><strong>Address: </strong>  {orderData.site_location[0].site_address}, {orderData.site_location[0].pincode_number}</p>
                    {/* Site Name: <p>{orderData.site_location[0].site_location}, {orderData.site_location[0].billing_city}</p> */}
                    {/* Address: <p>{orderData.site_location[0].site_address}</p> */}
                    {/* <div className="adrs" style={{ marginTop: "10px" }}>
                        {`${orderData.site_location[0].pincode_number}`}
                    </div> */}
                    <div className="gstn">
                      <strong>GSTN:</strong> {orderData.site_location[0].gst_number}
                    </div>
                  </div>
                </Col>
              </Row>
              {/*<div className="hltxt">*/}
                {/*Seller Final Offer Reference: {orderData.po_number} |{" "}*/}
                  {/*{orderData.material_description[0].delivery_date}*/}
              {/*</div>*/}
              <Table
                  className="poordertbl"
                  columns={columns}
                  dataSource={data}
                  pagination={false}
              />
              {/*<div className="invofooter">*/}
                {/*<table >*/}
                  {/*<tr>*/}
                    {/*<th>Basic Sub Total:</th>*/}
                    {/*<td>₹ {orderData.total[0].basic_sub_total.toFixed(2)}</td>*/}
                  {/*</tr>*/}
                  {/*<tr>*/}
                    {/*<th>CGST:</th>*/}
                    {/*<td>₹ {orderData.total[0].cgst.toFixed(2)}</td>*/}
                  {/*</tr>*/}
                  {/*<tr>*/}
                    {/*<th>SGST:</th>*/}
                    {/*<td>₹ {orderData.total[0].sgst.toFixed(2)}</td>*/}
                  {/*</tr>*/}
                  {/*<tr>*/}
                    {/*<th>Total:</th>*/}
                    {/*<td>₹ {orderData.total[0].total.toFixed(2)}</td>*/}
                  {/*</tr>*/}
                {/*</table>*/}
              {/*</div>*/}
              {/*<div className="hltxt">AMOUNT IN WORDS: <b>{convertNumberToWords(orderData.total[0].total.toFixed(2))}</b></div>*/}
              <Row gutter={[15]}>
                <Col xs={24} sm={24} md={12}>
                  <div className="orderpdtl ftrsigntbl">
                    <h3>Other Terms: The Seller has accepted order unconditionally.</h3>
                    <p>
                        <strong>For, {orderData.company_name}</strong>
                    </p>
                      <p className="authsign">
                          <br /><br />
                          Authorised Signatory
                      </p>
                  </div>
                </Col>
                <Col xs={24} sm={24} md={12}>
                  <div className="orderpdtl ftrsigntbl rightalign">
                    <h3></h3>
                      <p>
                          <strong>For, {orderData.vendor_details[0].vendor_name}</strong>
                      </p>
                      <p className="authsign">
                          <br /><br />
                          Authorised Signatory
                      </p>
                  </div>
                </Col>
              </Row>
            </div>

          </section>
        </div>
        </>
    );
};


export default ApproveRFQView;
